import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { uploadFileAction } from "../../../redux/actions/GlobalAction";
import { getInfrastructureDetailsAction } from "../../../redux/actions/InfrastructureDetailsAction";
import { getSnackbarSuccess, MandatoryStar } from "../../../Utils/helper";
import { callHomePageAPI, removeImageHandler } from "../CommonComponent/commonfunctionality";
import { FacilityImageMultiple } from "./FacilityImageMultiple";

const FacilitiyImage = ({ isPageEdit,source }) => {
  const dispatch = useDispatch();
  const getInfrastructureDetails = useSelector(
    (state) =>
      state?.InfrastructureDetailsReducer?.getInfrastructureDetails
        ?.infrastructureDetails
  );

  return (
    <div className="Facility-Images-section mt-5">
      <h2 className="mb-3">Facility Images</h2>
      <p className="disclaimer-box mt-4">
        These images are viewed by the Customer.
      </p>
      <p
        className="form-text mt-3"
        style={{ marginLeft: "0px", fontSize: "13px" }}
      >
        Note : File Types allowed are JPG, JPEG, PNG. Maximum upload size is 2
        MB.
      </p>
      <div className="row align-items-center flex-wrap facility-images-item">
        <div className="col-md-3">
          <h3>
          Logo <MandatoryStar />
          </h3>
        </div>
        <div className="col-md-9 d-flex flex-wrap align-items-center">
          {getInfrastructureDetails?.logo !== null && (
            <p className="img-text">
              <a
                className="upload-img me-2 img-name"
                target="blank"
                href={getInfrastructureDetails?.logo?.imageUrl}
              >
                logo
              </a>
              {isPageEdit && (
                <img
                  src="https://live.healthassure.in/ProvidersPortal/images/removeicon.png"
                  type="button"
                  onClick={async () => {
                    await removeImageHandler(
                      getInfrastructureDetails?.logo,
                      getInfrastructureDetailsAction,
                      true,
                      dispatch
                    );
                  }}
                  alt=""
                />
              )}
            </p>
          )}
          {getInfrastructureDetails?.logo === null && (
            <label className="btn btn-primary" style={{ cursor: "pointer" }}>
              <input
                type="file"
                id="imageUpload"
                style={{ width: "2px" }}
                name="DCLOGO"
                accept="image/jpeg, image/jpg, image/png"
                onChange={async (e) => {
                  const file = e.target.files[0];
                  if (file.size > 2097152) {
                    getSnackbarSuccess(
                      "info",
                      "Maximum upload file size is 2 MB.",
                      dispatch
                    );
                  } else if (
                    file.type !== "image/jpg" &&
                    file.type !== "image/jpeg" &&
                    file.type !== "image/png"
                  ) {
                    getSnackbarSuccess(
                      "info",
                      "File Types allowed are JPG, JPEG, PNG.",
                      dispatch
                    );
                  } else {
                    await dispatch(
                      uploadFileAction(e.target.files[0], "DCLOGO", dispatch)
                    );
                    await dispatch(getInfrastructureDetailsAction());
                    if(source !== "WhatsApp"  && source !== "Email"){
                      await callHomePageAPI(dispatch);
                    }
                  }
                }}
                disabled={!isPageEdit}
                required
              />
              <span style={{ cursor: !isPageEdit && "auto" }}>
                <img src="./images/uploadicon.svg" alt="" /> UPLOAD
              </span>
            </label>
          )}
        </div>
      </div>
      <FacilityImageMultiple
        imageArray={getInfrastructureDetails?.banner}
        docType="DCPICS"
        heading="Banner"
        imageUploadLength={4}
      />
      <FacilityImageMultiple
        imageArray={getInfrastructureDetails?.reception}
        docType="RECEPTION"
        heading="Reception"
        imageUploadLength={4}
      />
      <FacilityImageMultiple
        imageArray={getInfrastructureDetails?.waitingArea}
        docType="WAITINGAREA"
        heading="Waiting Area"
        imageUploadLength={4}
      />
      <FacilityImageMultiple
        imageArray={getInfrastructureDetails?.lab}
        docType="LAB"
        heading="Lab"
        imageUploadLength={4}
      />
      <FacilityImageMultiple
        imageArray={getInfrastructureDetails?.washroom}
        docType="WASHROOM"
        heading="Washroom"
        headingSub="(Indian/Western)"
        imageUploadLength={4}
      />
      <FacilityImageMultiple
        imageArray={getInfrastructureDetails?.medicalEquipment}
        docType="MEDICALEQUIPMENT"
        heading="Medical Equipment"
        headingSub="(TMT/ Echo/ Xray/ Ultrasound/ Height&Weight/ ECG)"
        imageUploadLength={7}
      />
    </div>
  );
};

export default FacilitiyImage;
